import React from 'react'

import FieldItem from "./option-item/field-item"
import {PopoverAddFieldsListProps} from "./index";
import FieldProto from "../../../../../fields3/proto/field-proto";

export default function CustomFields(props: PopoverAddFieldsListProps) {

    const group = _.find(props.config.groupedFields, group=>group.value === props.section);

    return (
        <>
            {_.map(group?.items, (field: FieldProto)=> {
                // const field = _.find(props.fields, (field)=>field.fieldId === fieldId);
                const selectedColumn = _.find(props.columns, column=>column.fieldId === field?.fieldId);
                const isSelectedField = _.intersection(props.selectedFieldIds, [field.fieldId, field.systemFieldId]).length > 0 //props.selectedFieldIds.includes(field.fieldId)

                if (!field) return null

                return <FieldItem key                   = {field.fieldId}
                                  field                 = {field}
                                  params                = {selectedColumn?.params}
                                  selected              = {!!selectedColumn || isSelectedField}
                                  hasIcons              = {true}
                                  showModifierOptions   = {props.showModifierOptions}
                                  onClick               = {props.onToggleColumn}/>
            })}

            {props.isAddVisible &&
                <div className="option" onClick={()=> {props.onSelectSection('new-field')}}>
                    <div className="label add">
                        New custom field
                    </div>
                </div>
            }
        </>
    );
}
